<script setup lang="ts">
  import type { ComplaintStatusDictionaryRecord } from '@storefront/resources';

  interface Props {
    status: ComplaintStatusDictionaryRecord;
  }

  defineProps<Props>();
</script>

<template>
  <span class="complaint-status" :class="status.class">
    {{ status.label }}
  </span>
</template>

<style lang="scss">
  :root {
    --complaint-status-label-color: var(--color-default);
    --complaint-status-label-background: var(--color-secondary);
    --complaint-status-label-radius: 0.625rem;
    --complaint-status-label-font-size: 0.75rem;
    --complaint-status-label-padding-y: 0.25rem;
    --complaint-status-label-padding-x: 0.75rem;

    --complaint-status-label-color-info: var(--sf-status-color-info);
    --complaint-status-label-background-info: var(--sf-status-background-info);
    --complaint-status-label-color-danger: var(--sf-status-color-danger);
    --complaint-status-label-background-danger: var(--sf-status-background-danger);
    --complaint-status-label-color-warning: var(--sf-status-color-warning);
    --complaint-status-label-background-warning: var(--sf-status-background-warning);
    --complaint-status-label-color-success: var(--sf-status-color-success);
    --complaint-status-label-background-success: var(--sf-status-background-success);
  }

  .complaint-status {
    display: inline-block;
    background-color: var(--complaint-status-label-background);
    color: var(--complaint-status-label-color);
    border-radius: var(--complaint-status-label-radius);
    font-size: var(--complaint-status-label-font-size);
    padding: var(--complaint-status-label-padding-y) var(--complaint-status-label-padding-x);
    font-weight: var(--font-weight-bold);

    &.new,
    &.waiting-for-response {
      background: var(--complaint-status-label-background-info);
      color: var(--complaint-status-label-color-info);
    }

    &.accepted,
    &.in-progress,
    &.waiting-for-product {
      background: var(--complaint-status-label-background-warning);
      color: var(--complaint-status-label-color-warning);
    }

    &.completed {
      background: var(--complaint-status-label-background-success);
      color: var(--complaint-status-label-color-success);
    }

    &.rejected {
      background: var(--complaint-status-label-background-danger);
      color: var(--complaint-status-label-color-danger);
    }
  }
</style>
